<template>
  <div class="wrapper">
    <div class="logo" @click="openPortalLink()" />
    <demo-alert />
    <div
      ref="profileRef"
      class="nav-item no-hover profile right flex-align-right flex-right"
      @click="toggele"
    >
      <ClientOnly>
        <header-popover :visible="visible" :virtual-ref="profileRef">
          <div class="text-block" @click="openPortalLink()">
            トップに戻る
          </div>
          <hr>
          <div class="text-block">
            <cs-link
              text-decoration="none"
              :href="termsOfServiceUrl"
              target="_blank"
              rel="nofollow noopener">
              利用規約
            </cs-link>
          </div>
          <hr>
          <div class="text-block">
            <cs-link
              text-decoration="none"
              :href="policyUrl"
              target="_blank"
              rel="nofollow noopener">
              プライバシーポリシー
            </cs-link>
          </div>
          <hr>
          <div class="text-block" @click="emit('logout')">
            ログアウト
          </div>
        </header-popover>
      </ClientOnly>
      <div class="name2">
        {{ name }}
      </div>
      <el-icon><CaretBottom /></el-icon>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from '#app'
import { CaretBottom } from '@element-plus/icons-vue'

const profileRef = ref<HTMLElement | null>(null)
import HeaderPopover from '~/components/HeaderPopover.vue'
import { SelectedItem } from '~/components/NavbarSelectedItem'
import CsLink from '~/components/CsLink.vue'
import { unifaPolicyUrl, termsOfServiceUrl, portalDashboardUrl } from '~/helpers/constUrls'
import DemoAlert from '~/components/DemoAlert.vue'

const props = withDefaults(
  defineProps<{
    name?: string
    selectedItem?: SelectedItem
  }>(),
  {
    selectedItem: 'top'
  }
)

const emit = defineEmits<{
  (e: 'logout'): void
}>()

const router = useRouter()

const visible = ref(false)
const policyUrl = unifaPolicyUrl

const isTop = computed(() => props.selectedItem === 'top')
const isShift = computed(() => props.selectedItem === 'shift')
const isWork = computed(() => props.selectedItem === 'work')
const isSetting = computed(() => props.selectedItem === 'setting')

const linkTo = (link: string): void => {
  router.push(link)
}

const openPortalLink = (): void => {
  window.location.href = portalDashboardUrl()
}

const toggele = (event: Event): void => {
  event.stopPropagation()
  visible.value = !visible.value
}

const closeMenu = (event: Event): void => {
  if (profileRef.value && !profileRef.value.contains(event.target as Node)) {
    visible.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', closeMenu)
})

onUnmounted(() => {
  document.removeEventListener('click', closeMenu)
})

const alertMessage = (message: string): void => {
  alert(message)
}
</script>

<style lang="sass" scoped>
.wrapper
  height: 50px
  background-color: #c39143
  display: flex
  align-items: center
  color: #fff
  padding: 0 20px
  position: sticky
  top: 0px
  z-index: 1900

.text-block
  height: 64px
  display: flex
  align-items: center
  padding-left: 20px

.nav-item
  cursor: pointer
  padding: 3px 16px
  font-weight: bold
  border-radius: 16px
  white-space: nowrap
  img
    margin-right: 8px
    width: 20px
    height: 20px
    object-fit: contain
  &.right
    margin-left: auto
  &.profile
    padding: 0
    display: flex
    align-items: center
    cursor: pointer
    width: 240px
    > .name, > .name2
      margin-right: 5px
      white-space: nowrap
  &:hover
    background-color: rgba(255, 255, 255, 0.2)
  &.selected
    background-color: rgba(255, 255, 255, 0.2)
  &.no-hover
    &:hover
      background-color: inherit
  transition: all 0.3s ease 0s

.logo
  cursor: pointer
  background: url('~/assets/logo_header.png') center / contain no-repeat
  width: 108px
  height: 40px
</style>

